import Vue from 'vue';
export function isStoreInstance(obj) {
    return obj instanceof Vue;
}
export function hasSubModule(store, moduleName) {
    return !!getSubModules(store)[moduleName];
}
export function vueStoreConfig(store) {
    if (!store.$options)
        throw new Error('Class is not a Vue instance');
    return store.$options.$vuestore;
}
export function addMutationListener(store, fn) {
    addInterceptor(store, (context) => {
        context.handler();
        fn({ type: context.type, name: context.name, payload: context.payload });
    });
}
export function addInterceptor(store, fn, recursive = true) {
    const config = vueStoreConfig(store);
    config.interceptors.push(fn);
    if (recursive)
        Object.values(config.submodules).forEach((sm) => addInterceptor(sm, fn));
}
export function getSubModules(store) {
    return vueStoreConfig(store).submodules;
}
export function assert(condition, msg) {
    if (!condition)
        throw new Error(`[vuestore] ${msg}`);
}
//# sourceMappingURL=utils.js.map